export default __webpack_public_path__ + "static/media/lds-logo_es.a79c905454dfa1d8.svg";